export default "__VITE_ASSET__ac79da0a__"